import { DESKTOP_MEDIA_QUERY } from "@/common/constants";
import { useMediaQuery } from "@/utils/hooks";
import { getTimeDifference } from "@/utils/time";
import { FormattedRelativeTime } from "react-intl";

interface RelativeTimeProps {
  date: Date;
}

export const RelativeTime = ({ date }: Readonly<RelativeTimeProps>) => {
  const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY);
  const { value, unit, refreshInterval } = getTimeDifference(date);

  return (
    <time dateTime={date.toISOString()} suppressHydrationWarning>
      <FormattedRelativeTime
        value={-value}
        unit={unit}
        numeric="auto"
        updateIntervalInSeconds={refreshInterval}
        style={isDesktop ? "long" : "narrow"}
      />
    </time>
  );
};
